import { Box } from "@chakra-ui/react";
import { useTab } from "../../contexts/useTab";
import TableEmployeeKPI from "./tableEmployeeKPI";

export default function EmployeeKPI() {
 
  return (
    <Box
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px" }}
    >
      <TableEmployeeKPI />
    </Box>
  );
}
